export var RatingScale;
(function (RatingScale) {
    RatingScale[RatingScale["ONE_STAR"] = 1] = "ONE_STAR";
    RatingScale[RatingScale["TWO_STARS"] = 2] = "TWO_STARS";
    RatingScale[RatingScale["THREE_STARS"] = 3] = "THREE_STARS";
    RatingScale[RatingScale["FOUR_STARS"] = 4] = "FOUR_STARS";
    RatingScale[RatingScale["FIVE_STARS"] = 5] = "FIVE_STARS";
})(RatingScale || (RatingScale = {}));
export var RatingCategory;
(function (RatingCategory) {
    RatingCategory["SERVICE_QUALITY"] = "service_quality";
    RatingCategory["FRIENDLINESS"] = "friendliness";
    RatingCategory["PROFESSIONALISM"] = "professionalism";
    RatingCategory["SPEED"] = "speed";
    RatingCategory["KNOWLEDGE"] = "knowledge";
    RatingCategory["OVERALL"] = "overall";
})(RatingCategory || (RatingCategory = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhZmZSYXRpbmcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbmVrby1zdGFmZi9TdGFmZlJhdGluZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLENBQU4sSUFBWSxXQU1YO0FBTkQsV0FBWSxXQUFXO0lBQ3JCLHFEQUFZLENBQUE7SUFDWix1REFBYSxDQUFBO0lBQ2IsMkRBQWUsQ0FBQTtJQUNmLHlEQUFjLENBQUE7SUFDZCx5REFBYyxDQUFBO0FBQ2hCLENBQUMsRUFOVyxXQUFXLEtBQVgsV0FBVyxRQU10QjtBQUVELE1BQU0sQ0FBTixJQUFZLGNBT1g7QUFQRCxXQUFZLGNBQWM7SUFDeEIscURBQW1DLENBQUE7SUFDbkMsK0NBQTZCLENBQUE7SUFDN0IscURBQW1DLENBQUE7SUFDbkMsaUNBQWUsQ0FBQTtJQUNmLHlDQUF1QixDQUFBO0lBQ3ZCLHFDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFQVyxjQUFjLEtBQWQsY0FBYyxRQU96QiJ9